module.exports = "<li ng-show=\"tbSignOutCtrl.isSignedIn\" id=\"tb-ui-signout-root\" uib-dropdown>\n    <a href role=\"button\" uib-dropdown-toggle>{{ tbSignOutCtrl.userName }} <span class=\"caret\"></span></a>\n    <ul uib-dropdown-menu role=\"menu\">\n        <li><a href ng-click=\"tbSignOutCtrl.logout()\">Sign Out</a></li>\n    </ul>\n</li>\n"


//////////////////
// WEBPACK FOOTER
// ./src/directives/user-auth/TbSignOut.tpl.html
// module id = 7aKU
// module chunks = 1